export default __webpack_public_path__ + "a1c07de05032dd59b2efc4bc27c9eb1a.png";